module.exports = __webpack_public_path__ + "img/智能.7e74dda9.png";